import { Injectable } from "@angular/core";
import { NavigationLinkComponent } from "../components/navigation-link/navigation-link.component";

@Injectable({
  providedIn: "root",
})
export class StickyHeaderService {
  stickyElements = new Set<NavigationLinkComponent>();

  constructor() {
    document.addEventListener("click", this.onClick.bind(this));
  }

  // handle click. if outside of nav elements, clear all sticky
  onClick(event) {
    const srcElem = event.srcElement;
    const classes: DOMTokenList = srcElem.classList;
    if (classes.contains("nav-link") || classes.contains("dropdown-item")) {
      return;
    }
    this.clearStickyElements();
  }

  // only works for 2 deep nav elements
  handleSticky(navLink: NavigationLinkComponent) {
    // if it is already sticky
    if (this.stickyElements.has(navLink)) {
      // check if other sticky elements have the selected element as parent
      for (const elem of this.stickyElements) {
        if (elem == navLink) {
          continue;
        }
        // if other has selected as parent
        if (elem.parent == navLink) {
          this.removeStickElement(elem);
        }
      }
      this.removeStickElement(navLink);
    } else {
      // not sticky
      // if there are sticky elements, and not parent, remove
      for (const elem of this.stickyElements) {
        if (navLink.parent == elem) {
          continue;
        }
        this.removeStickElement(elem);
      }

      this.addStickyElement(navLink);
      // if has parent
      if (navLink.parent != null) {
        this.addStickyElement(navLink.parent);
      }
    }
  }

  addStickyElement(navLink: NavigationLinkComponent) {
    if (this.stickyElements.has(navLink)) {
      return;
    }
    navLink.setSticky();
    this.stickyElements.add(navLink);
  }

  removeStickElement(navLink: NavigationLinkComponent) {
    navLink.setNotSticky();
    this.stickyElements.delete(navLink);
  }

  clearStickyElements() {
    const stickyArr = Array.from(this.stickyElements);
    // want to set children not sticky first
    stickyArr.sort((a, b) => {
      return a.parent == null ? 1 : -1;
    });
    for (const navLink of stickyArr) {
      navLink.setNotSticky();
    }

    this.stickyElements.clear();
  }
}
